export enum TypeControle {
  QCM = "QCM",
  CNC = "CNC",
  QUANTITATIF = "QUANTITATIF",
  MARQUAGE = "MARQUAGE",
  ENREGISTREMENT = "ENREGISTREMENT",
  TRACABILITE = "TRACABILITE",
}

